import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 min-w-0" }
const _hoisted_2 = { class: "min-w-0" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "flex items-center gap-1 flex-shrink-0" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "flex flex-wrap gap-1.5" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AiChatPanelResizer = _resolveComponent("AiChatPanelResizer")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ContextChip = _resolveComponent("ContextChip")!
  const _component_ChatMessageList = _resolveComponent("ChatMessageList")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "ai-panel" }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("aside", {
              key: 0,
              ref: "panelEl",
              class: _normalizeClass([
          _ctx.isDark ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200',
          'fixed top-0 right-0 h-screen z-40 flex flex-col border-l shadow-2xl'
        ]),
              style: _normalizeStyle({ width: _ctx.widthPx + 'px' }),
              role: "complementary",
              "aria-label": "Atlas AI panel"
            }, [
              _createVNode(_component_AiChatPanelResizer),
              _createElementVNode("div", {
                class: _normalizeClass([
            _ctx.isDark ? 'bg-gray-800 border-gray-700' : 'bg-gray-50 border-gray-200',
            'flex items-center justify-between gap-2 px-3 py-2 border-b flex-shrink-0'
          ])
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", {
                    class: "text-base",
                    "aria-hidden": "true"
                  }, "🤖", -1)),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", {
                      class: _normalizeClass([
                  _ctx.isDark ? 'text-gray-100' : 'text-gray-900',
                  'font-semibold text-sm leading-none truncate'
                ])
                    }, " Atlas AI ", 2),
                    _createElementVNode("p", {
                      class: _normalizeClass([
                  _ctx.isDark ? 'text-gray-400' : 'text-gray-500',
                  'text-[11px] leading-tight mt-0.5 truncate'
                ]),
                      title: _ctx.routePath
                    }, _toDisplayString(_ctx.headerSubtitle), 11, _hoisted_3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_RouterLink, {
                    to: "/database/atlas-intel/atlas-ai-history",
                    class: _normalizeClass([
                _ctx.isDark ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700',
                'text-[11px] hover:underline px-1'
              ]),
                    title: "Open the full Atlas AI Chat page"
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("Open chat ↗")
                    ])),
                    _: 1,
                    __: [3]
                  }, 8, ["class"]),
                  _createElementVNode("button", {
                    class: _normalizeClass([
                _ctx.isDark ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700',
                'p-1 rounded'
              ]),
                    title: `Close (${_ctx.shortcutLabel('Esc')})`,
                    "aria-label": "Close Atlas AI panel",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.panel.close()))
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      class: "w-4 h-4",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M6 18L18 6M6 6l12 12"
                      })
                    ], -1)
                  ]), 10, _hoisted_5)
                ])
              ], 2),
              (_ctx.visibleChips.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass([
            _ctx.isDark ? 'border-gray-700' : 'border-gray-200',
            'flex flex-wrap gap-1.5 px-3 py-2 border-b flex-shrink-0'
          ])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleChips, (chip) => {
                      return (_openBlock(), _createBlock(_component_ContextChip, {
                        id: chip.id,
                        key: chip.id,
                        label: chip.label,
                        kind: chip.kind,
                        removable: chip.removable !== false,
                        onRemove: _ctx.onRemoveChip
                      }, null, 8, ["id", "label", "kind", "removable", "onRemove"]))
                    }), 128))
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.quickActions.length && !_ctx.hasSeededQuestion)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass([
            _ctx.isDark ? 'border-gray-700' : 'border-gray-200',
            'flex flex-col gap-1.5 px-3 py-2 border-b flex-shrink-0'
          ])
                  }, [
                    _createElementVNode("p", {
                      class: _normalizeClass([
              _ctx.isDark ? 'text-gray-400' : 'text-gray-500',
              'text-[10px] uppercase tracking-wide font-medium'
            ])
                    }, " Try asking ", 2),
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickActions, (q) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: q,
                          type: "button",
                          class: _normalizeClass([
                _ctx.isDark
                  ? 'bg-gray-800 hover:bg-gray-700 text-gray-200 border-gray-700'
                  : 'bg-white hover:bg-gray-50 text-gray-700 border-gray-300',
                'text-left text-[11px] leading-snug px-2 py-1 rounded-md border transition-colors'
              ]),
                          onClick: ($event: any) => (_ctx.onQuickAction(q))
                        }, _toDisplayString(q), 11, _hoisted_7))
                      }), 128))
                    ])
                  ], 2))
                : _createCommentVNode("", true),
              _createVNode(_component_ChatMessageList, {
                "connection-id": _ctx.activeChatId,
                "auto-run-question": _ctx.initialAutoRun,
                class: "flex-1 min-h-0"
              }, null, 8, ["connection-id", "auto-run-question"]),
              _createElementVNode("div", {
                class: _normalizeClass([
            _ctx.isDark
              ? 'border-gray-700 bg-gray-900 text-gray-500'
              : 'border-gray-200 bg-gray-50 text-gray-500',
            'border-t px-3 py-1.5 text-[10px] flex-shrink-0 flex justify-between items-center'
          ])
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.shortcutLabel('⌘K')) + " toggle · " + _toDisplayString(_ctx.shortcutLabel('⌘/')) + " focus · Esc close", 1),
                (_ctx.mutedChipCount > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "hover:underline",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.panel.unmuteAllChips()))
                    }, " Restore " + _toDisplayString(_ctx.mutedChipCount) + " chip" + _toDisplayString(_ctx.mutedChipCount === 1 ? '' : 's'), 1))
                  : _createCommentVNode("", true)
              ], 2)
            ], 6))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}